import React, { useState, useEffect} from "react";
import AppBar from "../components/app_bar/AppBar";
import Drawer from "../components/Drawer";
import { 
    Typography, CssBaseline, Box, Toolbar, Grid, ListItem, ListItemText, Switch, Divider,
    List, useMediaQuery, 
} from '@mui/material';

import * as CONSTANTS from "../constants"
import { useParams, useNavigate } from "react-router-dom";
import { useTheme } from '@mui/material/styles';
import ThemeToggle from "../components/user_setting/ThemeToggle";

import { redirect_home_if_sign_out } from "../utils/redirect_link";

const UserSetting = () => {  

    let {lang} = useParams();

    document.title = `${CONSTANTS.APP_BAR.USER_MENU.SETTING[lang]} - Wotagei Zone`

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));  // Mobile detection
    const navigate =  useNavigate();

    const [drawerOpen, setDrawerOpen] = useState(false);
            
    const handleDrawerOpen = (open) => {
        if (open === undefined) {
            setDrawerOpen(!drawerOpen)
        } else {
            setDrawerOpen(open);
        }
    }

    // Sign Out Event
    useEffect(() => {
        redirect_home_if_sign_out(navigate);
    }, [navigate]);
    
    return (
        <Box >
            <CssBaseline />
            <AppBar lang={lang} handleDrawerOpen={handleDrawerOpen}/>
            <Box sx={{ display: 'flex' }}>
                <Drawer lang={lang} drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} />
                <Box component="main" sx={{ flexGrow: 1, p: isMobile? 2: 3 }}>
                    <Toolbar />
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={12}>
                            <Typography 
                                xs={12}
                                variant="h5" 
                                style={{
                                    textAlign: "left",
                                    fontWeight: "bolder",
                                }}
                            >
                                {CONSTANTS.APP_BAR.USER_MENU.SETTING[lang].toUpperCase()}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <Box>
                                <Typography variant="h6" gutterBottom>{CONSTANTS.USER_SETTING.CATEGORY.GENERAL[lang]}</Typography>
                                <List>
                                    <ListItem>
                                        <ListItemText primary={CONSTANTS.USER_SETTING.ITEM.DARK_MODE[lang]} />
                                        <ThemeToggle />
                                    </ListItem>
                                </List>
                                <Divider />
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </Box>
    );
};
 
export default UserSetting;